import { paymentModeEnum } from "../../../../state/initialState";
import {
  removeGlobalErrorMessageIfMatchesThisString,
  updateGlobalErrorMessage
} from "../../../../actions/globalError";
import React, { Component } from "react";
import { connect } from "react-redux";
import objectAssign from "object-assign";
import {
  updateCheckoutAppointmentStepData,
  findGiftCertificate,
  removeGiftCertificate
} from "../../../../actions/checkoutAppointmentStep";
import { decimalPoint } from "../../../../utils/helpers";
import { ValidMe } from "../../../shared/validMeReact";
import Txt from "../../../shared/textInput";

@connect(mapStateToProps)
export default class GiftCertPaymentForm extends Component {
  constructor(props) {
    super(props);
  }

  dispatchUpdateCheckoutAppointmentStepData = data => {
    this.props.dispatch(updateCheckoutAppointmentStepData(data));
  };

  updateCheckoutStep = data => {
    let newData = objectAssign(
      {},
      this.props.checkoutAppointmentStepData,
      data
    );
    this.dispatchUpdateCheckoutAppointmentStepData(newData);
  };

  handleGiftCertCodeChange = ev => {
    const giftCertCode = ev.target.value.toUpperCase();
    this.updateCheckoutStep({
      giftCertCode: giftCertCode,
      giftCertRedemptionAmount: "0"
    });
    this.props.dispatch(removeGiftCertificate());
    this.props.dispatch(updateGlobalErrorMessage(""));
  };

  removeExistingGiftCertData = () => {
    this.updateCheckoutStep({
      giftCertCode: "",
      giftCertRedemptionAmount: "0",
      removeExistingGiftCertData: false
    });
    this.props.dispatch(removeGiftCertificate());
  };

  applyGiftCertHandler = () => {
    let { giftCertCode } = this.props.checkoutAppointmentStepData;
    if (giftCertCode.length > 0) {
      this.props.dispatch(findGiftCertificate(giftCertCode));
    }
  };

  canCheckoutCurrentBooking = () => {
    let { limitedPermissions, currentBookingId } = this.props;
    return (
      limitedPermissions.canCheckoutAllBookings ||
      limitedPermissions.bookingsCheckoutableByCurrentUser.indexOf(
        currentBookingId
      ) > -1
    );
  };

  changeRedemptionAmountWithinConstraints = ev => {
    let { InvoiceCantBeOverpaid } = window.APP.LANGUAGE.Errors;
    const { outstandingamount } = this.props.invoiceData;
    const { balance } = this.props.foundGiftCertData;
    let redemptionAmount = ev.target.value.replace("$", "");

    if (
      (/[0-9]+\.?([0-9]{0,2})?$/.test(redemptionAmount) &&
        Number(redemptionAmount) <= outstandingamount &&
        Number(redemptionAmount) <= balance) ||
      redemptionAmount.length == 0
    ) {
      const decimalPlace = redemptionAmount.split(".")[1];
      if (decimalPlace && decimalPlace.length > 2) {
        return;
      }
      this.updateCheckoutStep({ giftCertRedemptionAmount: redemptionAmount });
      this.props.dispatch(
        removeGlobalErrorMessageIfMatchesThisString(InvoiceCantBeOverpaid)
      );
    }
  };

  formatRedemptionField = () => {
    let { giftCertRedemptionAmount } = this.props.checkoutAppointmentStepData;
    this.updateCheckoutStep({
      giftCertRedemptionAmount: decimalPoint(giftCertRedemptionAmount)
    });
  };

  getGiftCertPaymentForm = () => {
    const { paymentMode, invoiceData, foundGiftCertData } = this.props;
    let {
      giftCertCode,
      giftCertRedemptionAmount,
      removeExistingGiftCertData
    } = this.props.checkoutAppointmentStepData;
    let { Currency } = window.APP.LANGUAGE;
    let {
      GiftCertPlaceholder,
      GiftCertButtonText,
      GiftCertAvailableText,
      GiftCertRedemptionText,
      PaymentAmountPlaceholder
    } = window.APP.LANGUAGE.Pages.AppointmentCheckout;
    let { PaymentAmountMissing } = window.APP.LANGUAGE.Errors;
    let disabled = !this.canCheckoutCurrentBooking();

    const disablePayment = invoiceData.status == "PAID";
    const disableApplyBtn = giftCertCode.length == 0;
    var giftCertBalance = 0;
    var disableRedemption = disablePayment || foundGiftCertData == null;
    if (foundGiftCertData != null) {
      giftCertBalance = foundGiftCertData.balance;
      disableRedemption =
        disablePayment || foundGiftCertData == null || giftCertBalance <= 0;
    }
    if (removeExistingGiftCertData) {
      this.removeExistingGiftCertData();
    }
    return (
      <div className="ui form gift_cert_form">
        <div>
          <Txt
            maxLength="10"
            className="giftcert_code"
            disabled={disablePayment}
            type="input"
            fieldclasses="mrnull"
            onChange={this.handleGiftCertCodeChange}
            placeholder={GiftCertPlaceholder}
            value={giftCertCode}
          ></Txt>
          <div
            onClick={this.applyGiftCertHandler}
            disabled={disableApplyBtn}
            className={`ui right floated button applycert_btn ${
              disableApplyBtn ? "disabled" : ""
            }`}
          >
            {GiftCertButtonText}
          </div>
          <span className="giftcert_availableText">
            {GiftCertAvailableText +
              " " +
              Currency +
              decimalPoint(giftCertBalance)}
          </span>
        </div>
        <div>
          <div className="redemptionLabel">
            <label className="redemptionLabel_title">
              {GiftCertRedemptionText}
            </label>
          </div>
          <div className="totalLabel">
            <ValidMe
              validmemessage={PaymentAmountMissing}
              fieldclasses="mrnull"
              validmefor="required"
              group="thirdStepCheckoutAppointment"
            >
              <Txt
                type="input"
                onBlur={this.formatRedemptionField}
                fieldclasses="mrnull"
                className="redemption_amount active"
                disabled={disableRedemption}
                onChange={this.changeRedemptionAmountWithinConstraints}
                placeholder={PaymentAmountPlaceholder}
                value={
                  giftCertRedemptionAmount > 0
                    ? Currency + giftCertRedemptionAmount
                    : ""
                }
              ></Txt>
            </ValidMe>
          </div>
        </div>
      </div>
    );
  };

  render() {
    return <div>{this.getGiftCertPaymentForm()}</div>;
  }
}

function mapStateToProps(state) {
  return {
    currentBookingId: state.bookingReducer.currentBookingId,
    paymentMode: state.appointmentCheckoutReducer.paymentMode,
    limitedPermissions: state.appointmentStepReducer.limitedPermissions,
    invoiceData: state.appointmentCheckoutReducer.invoiceData,
    checkoutAppointmentStepData:
      state.appointmentCheckoutReducer.checkoutAppointmentStepData,
    foundGiftCertData: state.appointmentCheckoutReducer.foundGiftCertData
  };
}
